import Lenis from 'lenis';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { navigationHandlers, navigationScripts, } from './components/campaign-page/navigation/navigation';
import { imageModalHandler } from './components/campaign-page/image-modal/image-modal';
import { carouselAnimationSetup } from './components/campaign-page/carousel/carousel';
import { scrollyTellAnimationSetup } from './components/campaign-page/scrollytell/scrollytell';
import { progressBarAnimationSetup } from './components/campaign-page/progress-bar/progress-bar';
import { introAnimationSetup } from './components/campaign-page/intro/intro';
import { doubleImageAnimationSetup } from './components/campaign-page/double-image/double-image';
const lenis = new Lenis();
lenis.on('scroll', ScrollTrigger.update);
gsap.ticker.add(time => {
    lenis.raf(time * 1000);
});
gsap.ticker.lagSmoothing(0);
gsap.registerPlugin(ScrollTrigger);
const onModalOpen = () => lenis.stop();
const onModalClose = () => lenis.start();
navigationScripts();
imageModalHandler(onModalOpen, onModalClose);
scrollyTellAnimationSetup(gsap, ScrollTrigger);
carouselAnimationSetup(gsap, ScrollTrigger);
progressBarAnimationSetup(gsap, ScrollTrigger);
introAnimationSetup(gsap, ScrollTrigger);
doubleImageAnimationSetup(gsap, ScrollTrigger);
let storedTitle;
window.addEventListener('DOMContentLoaded', () => {
    console.debug('Campaign script loaded');
    const title = document.querySelector('.spv-campaignPage__title');
    if (title) {
        storedTitle = title.textContent ?? '';
        const windowWidth = window.innerWidth;
        if (windowWidth < 768) {
            title.textContent = 'Kollektiv-historien';
        }
        else {
            title.textContent = storedTitle;
        }
        window.addEventListener('resize', () => {
            if (windowWidth < 768) {
                title.textContent = 'Kollektiv-historien';
            }
            else {
                title.textContent = storedTitle;
            }
        });
    }
});
document.querySelectorAll('[data-subchapterLink]').forEach(link => {
    const id = link.getAttribute('href');
    const parent = link.parentNode;
    if (!id) {
        console.error('No href attribute found on link:', link);
        return;
    }
    const targetElement = link === parent?.firstChild ? parent : document.getElementById(id?.substring(1));
    const handleNavigation = (event) => {
        event.preventDefault();
        if (!targetElement || targetElement === null) {
            console.error('Target element not found:', id);
            return;
        }
        navigationHandlers.toggleNavigation();
        lenis.scrollTo(targetElement, {
            duration: 1.5,
            easing: t => t * (2 - t),
            offset: -200,
        });
    };
    link.addEventListener('click', handleNavigation);
    link.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
            handleNavigation(event);
        }
    });
});
document.querySelectorAll('a.spv-campaignPage__navigationButton').forEach(link => {
    const id = link.getAttribute('href');
    const targetElement = document.getElementById(id?.substring(1) || '');
    if (!id) {
        console.error('No href attribute found on link:', link);
        return;
    }
    if (!targetElement || targetElement === null) {
        console.error('Target element not found:', id);
        return;
    }
    link.addEventListener('click', event => {
        event.preventDefault();
        navigationHandlers.closeNavigation();
        lenis.scrollTo(targetElement, {
            duration: 1.5,
            easing: t => t * (2 - t),
            offset: -200,
        });
    });
    link.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            navigationHandlers.closeNavigation();
            lenis.scrollTo(targetElement, {
                duration: 1.5,
                easing: t => t * (2 - t),
                offset: -200,
            });
        }
    });
});
//# sourceMappingURL=campaign.js.map